import { PdSkinAnalyzerVariant } from '@notino/shared/definitions/types';

import { BrandsId } from '@containers/ProductDetailContainer/ProductDetail/model';
import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetail/ProductDetailContext';
import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';

const ALLOWED_CATEGORY_ID = 3645;
const ALLOWED_BRAND_IDS = [BrandsId.Estee, BrandsId.Roche];

export const useAnalyzerVisibility = () => {
  const {
    product: {
      brand: { id: brandId },
      categorization,
    },
  } = useProductDetailContext();

  const { pdSkinAnalyzerVariant } = useFeatureFlags();

  const shouldShowAnalyzer =
    ALLOWED_BRAND_IDS.includes(String(brandId) as BrandsId) &&
    Number(categorization?.categories?.[0]?.id) === ALLOWED_CATEGORY_ID;

  const isVariant1 = pdSkinAnalyzerVariant === PdSkinAnalyzerVariant.Variant1;
  const isVariant2 = pdSkinAnalyzerVariant === PdSkinAnalyzerVariant.Variant2;

  return { shouldShowAnalyzer, isVariant1, isVariant2 };
};
